import { createSlice } from '@reduxjs/toolkit';

import { initialMarketPriceState } from './initialState';
import { getMarketPrice } from 'src/thunk/marketPrice';
import { ERequestStatus } from 'src/api/enumRequest';

const MarketPriceSlice = createSlice({
  name: 'marketPrice',
  initialState: initialMarketPriceState,
  reducers: {
    resetMarketPrice: (state) => {
      state.getMarketPrice.status = ERequestStatus.none;
      state.getMarketPrice.marketPrice = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getMarketPrice.pending, (state) => {
        state.getMarketPrice.status = ERequestStatus.pending;
        state.getMarketPrice.marketPrice = state.getMarketPrice.marketPrice
          ? { ...state.getMarketPrice.marketPrice, expiration: 0 }
          : null;
        state.getMarketPrice.error = '';
      })
      .addCase(getMarketPrice.fulfilled, (state, action) => {
        const { source_currency_id, target_currency_id, price, source_currency_amount } = action.payload;

        state.getMarketPrice.status = ERequestStatus.success;
        state.getMarketPrice.marketPrice = {
          source_currency_id,
          target_currency_id,
          price,
          source_currency_amount,
          expiration: 30,
        };
      })
      .addCase(getMarketPrice.rejected, (state, action: any) => {
        state.getMarketPrice.status = ERequestStatus.failed;
        state.getMarketPrice.error = action.payload.message;
      });
  },
});

export const { resetMarketPrice } = MarketPriceSlice.actions;
export default MarketPriceSlice.reducer;
